import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map, flatMap } from 'rxjs/operators';

import {
  AppSettingsService,
  AuthenticationService,
  BaseService,
  ServiceManager,
} from 'iui-iconectiv-lib';

// import { QueryPaging } from '../shared';
// import { GenericResponse } from '../shared';


// export class AccountListResponse extends GenericResponse {
//   accountListResponse: any;
// }


@Injectable()
export class RegisterService extends BaseService {
  constructor(
    serviceManager: ServiceManager,
    private http: HttpClient,
    private appSettings: AppSettingsService,
    private authService: AuthenticationService
  ) {
    super(serviceManager);
  }

  registerAccount(accountJson: string): Observable<any> {
    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + '/api/account';
      return this.http.post(url, accountJson, { headers: new HttpHeaders().append('Content-Type', 'application/json') });
    })));
  }
}
